import { useState } from 'react';
import { useObjectMemo } from '@monkvision/common';
import { DateFilter, SortByProperty, SortDirection, DashboardInspectionListFilters } from './types';
import { DashboardInspectionStatus } from '../useInspectionList/types';

export interface UseInspectionListFiltersResult {
  filters: DashboardInspectionListFilters;
  toggleSortBy: (property: SortByProperty) => void;
  filterByStatuses: (value: DashboardInspectionStatus[] | null) => void;
  filterBySearchInput: (value: string | null) => void;
  filterByDate: (filterByLastUpdated: boolean, min: Date | null, max: Date | null) => void;
}

function opposite(dir: SortDirection): SortDirection {
  return dir === SortDirection.ASCENDING ? SortDirection.DESCENDING : SortDirection.ASCENDING;
}

export function useInspectionListFilters(): UseInspectionListFiltersResult {
  const [sortDirection, setSortDirection] = useState(SortDirection.DESCENDING);
  const [sortBy, setSortBy] = useState(SortByProperty.LAST_UPDATED);
  const [statuses, setStatuses] = useState<DashboardInspectionStatus[] | null>(null);
  const [lastUpdated, setLastUpdated] = useState<DateFilter | null>(null);
  const [searchInput, setSearchInput] = useState<string | null>(null);

  const filters = useObjectMemo({
    sortDirection,
    sortBy,
    statuses,
    lastUpdated,
    searchInput,
  });

  const toggleSortBy = (property: SortByProperty) => {
    if (sortBy === property) {
      setSortDirection((value) => opposite(value));
    } else {
      setSortBy(property);
      setSortDirection(SortDirection.DESCENDING);
    }
  };

  const filterByStatuses = (value: DashboardInspectionStatus[] | null) => {
    setStatuses(value);
  };

  const filterBySearchInput = (value: string | null) => {
    setSearchInput(value);
  };

  const filterByDate = (filterByLastUpdated: boolean, min: Date | null, max: Date | null) => {
    if (!min || !max) {
      setLastUpdated(null);
    } else {
      setLastUpdated(filterByLastUpdated ? { min, max } : null);
    }
  };

  return {
    filters,
    toggleSortBy,
    filterByStatuses,
    filterBySearchInput,
    filterByDate,
  };
}
